import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  DEFAULT_LOCALE_FLAGS,
  LocaleFlagToggle,
  buildLocaleLabelKey,
  resolveActiveLocaleCode,
  resolveDocumentLang,
  type LocaleFlagTogglePlacement,
} from 'pi-kiosk-shared/ui';

export interface HeaderLanguagePillsProps {
  readonly placement?: LocaleFlagTogglePlacement;
  readonly dataTestId?: string;
}

/** CZ / EN / SK flag toggle — same DEFAULT_LOCALE_FLAGS as customer / kiosk / pickup. */
export function HeaderLanguagePills({
  placement = 'header',
  dataTestId = 'enterprise-header-language',
}: HeaderLanguagePillsProps): JSX.Element {
  const { t, i18n } = useTranslation('admin');
  const activeLocale = resolveActiveLocaleCode(i18n.language, DEFAULT_LOCALE_FLAGS);

  useEffect(() => {
    document.documentElement.lang = resolveDocumentLang(activeLocale, DEFAULT_LOCALE_FLAGS);
  }, [activeLocale]);

  return (
    <LocaleFlagToggle
      locales={DEFAULT_LOCALE_FLAGS}
      activeLocale={activeLocale}
      onSelect={(code) => {
        if (code !== activeLocale) {
          void i18n.changeLanguage(code);
        }
      }}
      getLabel={(code) => t(buildLocaleLabelKey(code))}
      groupLabel={t('shell.language.groupLabel')}
      surface="admin"
      placement={placement}
      dataTestId={dataTestId}
    />
  );
}
